import React from 'react';
import { motion } from 'framer-motion';
import CaseCard from '../components/CaseCard';
import { cases } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Cases = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  return (
    <div className="pt-20 bg-white">
      {/* Hero Section */}
      <section className="py-20 px-6 lg:px-12 bg-black text-white">
        <div className="max-w-5xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            {t.cases.title.split(' ')[0]} <span className="text-[#ff5200]">{t.cases.title.split(' ')[1]}</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl text-gray-300"
          >
            {t.cases.subtitle}
          </motion.p>
        </div>
      </section>

      {/* Cases Grid */}
      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cases.map((caseItem) => (
              <CaseCard key={caseItem.id} caseItem={caseItem} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cases;